<template>
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.3333 1.5H1.66663L8.33329 9.38333V14.8333L11.6666 16.5V9.38333L18.3333 1.5Z" stroke="#A4A4A4" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
